// extracted by mini-css-extract-plugin
export default {"flex":"ingredient-tabs_flex__Clc2Z","justifyCenter":"ingredient-tabs_justifyCenter__K8kkV"};